import React, { useEffect, useState } from 'react';
import { apiRequest } from "../services/api";
import { useNavigate } from 'react-router-dom';
import { Link } from 'react-router-dom';

const Visa = () => {
    const [data, setData] = useState([]);
    const navigate = useNavigate();
    useEffect(() => {
        apiRequest({ url: "/visa" })
            .then((res) => {
                if (res.success && Array.isArray(res.data)) {
                    const shuffled = res.data.sort(() => 0.5 - Math.random());
                    const selected = shuffled.slice(0, 5);
                    setData(selected);
                    // setData(res.data);
                } else {
                    console.warn("Unexpected response format:", res);
                }
            })
            .catch((err) => {
                console.error("Error loading hero slides:", err.message);
            });
    }, []);


    return (
        <section className='bg-dark visa-section '>
            <div className="mx-auto text-center mb-5" style={{ maxWidth: '900px' }}>
                <h5 className="section-title px-3">Visa</h5>
                <h1 className="mb-0 text-white">Visa Services for Top Countries</h1>
            </div>
            <div className="container text-center">
                <div className="d-flex flex-wrap justify-content-center gap-5 p-3">
                    {data.map((item, index) => (
                        <div key={index} className="text-center" style={{ width: "150px", cursor: 'pointer' }} onClick={() => navigate(`/visa/${item.slug}`, { state: item.id })}>
                            <img
                                src={item.img}
                                alt={item.title}
                                className="img-fluid img-visa mb-2"
                            />
                            <h3 className="h6 mt-2 fw-semibold text-white">{item.title}</h3>
                        </div>
                    ))}
                </div>

                <Link
                    to="/visas"
                    className="btn-hover-bg btn btn-light mt-5 rounded-pill py-3 px-5"
                >
                    Explore More
                </Link>
            </div>
        </section>
    )
}

export default Visa